import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { EARNING_STATUS_TRANSLATIONS } from '../../../../services/data/data-constants-translations';

@Component({
  selector: 'gtd-ui-field-default-earning-history',
  templateUrl: './earning-history.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EarningHistoryComponent {
  @Input() data: [];
  @Input() title: string;
  @Input() text: string = $localize`:@@common.show:Show`;
  public statusTranslations = EARNING_STATUS_TRANSLATIONS;
  protected readonly EARNING_STATUS_TRANSLATIONS = EARNING_STATUS_TRANSLATIONS;
}
